import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-leaderboard-myavata-popup',
  templateUrl: './leaderboard-myavata-popup.page.html',
  styleUrls: ['./leaderboard-myavata-popup.page.scss'],
})
export class LeaderboardMyavataPopupPage implements OnInit {

  public avataImage: string = "1";
  public items: any[] = new Array(20); // avata images need to be get from the server

  constructor(private modalController: ModalController) { }

  ngOnInit() {
  }

  onConfirmClick() {
    this.modalController.dismiss();
  }

  onClickAvata(index){
    this.avataImage = index
  }

}
